(function() {
	'use strict';

	var body = document.getElementsByTagName('body')[0];
	var header = document.getElementsByTagName('header')[0];
	if(document.body.classList.contains('neos-backend')) {
		header.classList.add('fixed');
		document.addEventListener('Neos.PageLoaded', function(event) {
			document.getElementsByTagName('header')[0].classList.add('fixed');
		}, false);
		return;
	}

	var lastKnownScrollPosition = window.pageYOffset;
	var isTicking = false;

	function onScroll(scrollPos) {
		if (scrollPos > 60) {
			header.classList.add('fixed');
		} else {
			header.classList.remove('fixed');
		}
	}

	window.addEventListener('scroll', function(e) {
		lastKnownScrollPosition = window.pageYOffset;
		if (!isTicking) {
			window.requestAnimationFrame(function() {
				onScroll(lastKnownScrollPosition);
				isTicking = false;
			});
		}
		isTicking = true;
	});

	// make sure to test on page load
	onScroll();

}());
